<template>
  <section>
    <div>
      <button
        v-if="park.Corporation.code != 'DOCOMO'"
        class="bottom-button"
        @click="goToExternalApp"
      >
        公式アプリへ
      </button>
      <button
        v-else-if="park.Corporation.code == 'DOCOMO' && !isNotTargetVersion"
        class="bottom-button"
        @click="goToDbsApp"
      >
        公式アプリへ
      </button>
      <button
        v-else-if="park.Corporation.code == 'DOCOMO' && isNotTargetVersion"
        class="disable bottom-button"
      >
        <b>公式アプリへ</b>
        <br />
        ※アプリを更新して再度お試しください
      </button>
    </div>
  </section>
</template>

<script>
import { computed, onMounted, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import API from "@/API";
import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";
export default {
  name: "DbsDetailButtons",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const appVersion = computed(() => store.getters["common/appVersion"]);
    const device = computed(() => store.getters["common/device"]);
    const isNotTargetVersion = ref(false);

    const DialogLoading = ref(null);

    const goToSelectCycle = async (type) => {
      await getReservationStatus();

      //comment because DBS Function end
      // if (myReservation) {
      //   if (myReservation.value.status == "none") {
      //     dbsService.goToSelectCycle(props.park, type);
      //   } else {
      //     openDialogAlreadyReserved();
      //   }
      // }
    };

    const getReservationStatus = async () => {
      DialogLoading.value.openDialog();
      await API.getDbsReservation();
      DialogLoading.value.closeDialog();
    };

    const goToExternalApp = () => {
      dbsService.goToExternalApp(props.park);
    };

    const goToDbsApp = () => {
      dbsService.goToDbsApp(props.park);
    };

    const isInAvailableArea = computed(() =>
      dbsService.isInAvailableArea(props.park)
    );

    onMounted(() => {
      console.log("DbsDetailButtons :: onMounted");
      nativeHandlerService.ncAppVersion();

      checkVersion();
    });

    const checkVersion = () => {
      let isLessThanTargetVersion = false;
      switch (device.value) {
        case "IOS":
          isLessThanTargetVersion =
            appVersion.value == "undefined" ||
            convertVersionForCompare(appVersion.value) <
              convertVersionForCompare("2.7.3");
          break;
        case "ANDROID":
          isLessThanTargetVersion =
            appVersion.value == "undefined" ||
            convertVersionForCompare(appVersion.value) <
              convertVersionForCompare("2.7.3");
          break;
        default:
          isLessThanTargetVersion = false;
          break;
      }
      isNotTargetVersion.value = isLessThanTargetVersion;
    };

    watchEffect(() => {
      if (appVersion.value != null) {
        checkVersion();
      }
    });

    // x.x.x(string)のバージョンを、比較用の数値に変換する
    const convertVersionForCompare = (ver) => {
      const verNums = ver.split(".");
      return verNums[0] * 100 + verNums[1] * 10 + verNums[2];
    };

    return {
      goToSelectCycle,
      goToExternalApp,
      goToDbsApp,
      isInAvailableArea,
      DialogLoading,
      isNotTargetVersion,
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-button {
  background: #ffb206;
  width: 100%;
  display: block;
  border: none;
  /* margin: 0.5vw auto; */
  font-size: 13px;
  color: white;
  font-weight: bold;
  height: 42px;
  position: fixed;
  bottom: 0;
  border-radius: 0px 0px 10px 10px;
}

.upper {
  bottom: 43px;
  border-radius: 10px 10px 0px 0px;
}

button.disable {
  background-color: #e9e9e9;
  color: #999999;
  height: 64px;
}
</style>
